import "bootstrap/dist/css/bootstrap.min.css";
import ReactDOM from "react-dom/client";

import App from "./components/App";
import { ThemeProvider } from "./context/ThemeContext";
// import { Sugar } from 'react-preloaders2';
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <App />
{/* <Sugar background="#0B1322" color='#215F80' time={2000}/> */}
  </ThemeProvider>
);
